module.exports = __webpack_public_path__ + "static/media/storage.07c7d35b.svg";